// extracted by mini-css-extract-plugin
export default {"btn":"SettingsButton__btn___P6KmW","icon":"SettingsButton__icon___w15lK fa fa-sliders-h"};